import React, { useCallback, useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../css/entry.css";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import dayjs from "dayjs";
import SriyanshCardHeader from "../../components/CardHeader";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import EncryptService from "../../service/EncryptionService";
import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import CustomDropdownMenu from "../../CustomComponant/DropDownMenu";
import TablewithSumFooter from "../../CustomComponant/TablewithSumFooter";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { set } from "lodash";

import CircularProgress from "@mui/material/CircularProgress";
//import { useAuthentication } from "../../customHook/useAuthentecation";

function ItemReceivedEntry() {
  const navigate = useNavigate();
  const today = dayjs();
  const [unsuitablePOList, setunsuitablePOList] = useState([]);
  const [npoNumber, setpoNumber] = useState("");
  const [poItemName, setpoItemName] = useState("");
  const [poValue, setpoValue] = useState(0);
  const [poQuantity, setpoQuantity] = useState(0);
  const [suitabilityDone,setSuitabilityDone]=useState(null);
  const [poDate, setpoDate] = useState(Date);
  const [dpDate, setDPDate] = useState(Date);
  const [ConsigneeName, setConsigneeName] = useState("");
  const { state } = useLocation();
  let indentId = state.indent_id;

  const [itemreceivedDate, setitemreceivedDate] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const maxDate =
    dpDate && dayjs(dpDate).isBefore(today) ? dayjs(dpDate) : today;

  const [error, setError] = useState("");
  const [reason, setreason] = useState("");
  
  const [GeMNumber, setGeMNumber] = useState("");
  const [GemDate, setGemDate] = useState("");


  const [receivedQuantity, setreceivedQuantity] = useState();
  const [receivedValue, setreceivedValue] = useState();

  const [totBalanceqty, settotBalanceqty] = useState(0);
  const [totBalanceVal, settotBalanceVal] = useState(0);

  const [minCalDate, setMinCalDate] = useState(dayjs());

  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const [errors, setErrors] = useState({});

  const [selectedOption, setSelectedOption] = useState("");

  const [itemselectedOption, setitemselectedOption] = useState("");

  const [getpass, setgetpass] = useState("");

  const [showRemark, setShowRemark] = useState(true);

////// canclelation  tools
const [showcancleRemark, setShowcancleRemark] = useState(false);
const [cancleRemark, setcancleRemark] = useState("");

 const [pageLoader, setPageLoader] = useState(false);


  const [POReturnData, setPOReturnData] = useState([]);

  const [poindentnumber, setpoindentnumber] = useState("");

  const [tpiagency, settpiAgency] = useState("");
  const [tpiDate, setTpiDate] = useState(null);

  const [totalreceivedQuantity, settotalreceivedQuantity] = useState(0);
  const [totalreceivedValue, settotalreceivedValue] = useState(0);

  const handleButtonClick = (row) => {
  
  // console.log(row.getpassnumber);
  try {
      const response1 = apiClient.post("/suitabilityUpdate", {
        vponumber: String(indentId),
        vgetpassnumber: row?.getpassnumber,
        ventryuser: uname,
        vip: ip,
      });
      alert(response1?"Data Transfered to  Next Step" : "Check Data");
      handleClose();
    } catch (error) {
      setError(error.response1 ? error.response1.data : error.message);
    }
  };

  const handleOptionitemChange = (event) => {
    setitemselectedOption(event.target.value);
    setErrors({ selerr: "" });
  };

  const handleOptionChange = (event) => {
    const selvalue = event.target.value;
    setSelectedOption(event.target.value);
    if (selvalue === "0") {
      setShowRemark(true);
      // setReason("");
    } else {
      setShowRemark(false);
    }
    setErrors({ selerr: "" });
  };

  const handleQuantityChange = (value) => {
    setreceivedQuantity(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  // const handleDateChange = (date) => {
  //   // Perform validation
  //   if (!date) {
  //     setError('Date is required.');
  //   } else if (dayjs(date).isBefore(minCalDate)) {
  //     setError(`Date cannot be earlier than ${minCalDate.format('YYYY-MM-DD')}`);
  //   } else if (dayjs(date).isAfter(today)) {
  //     setError(`Date cannot be later than ${today.format('YYYY-MM-DD')}`);
  //   } else {
  //     setError(''); // Clear error if validation passes
  //   }

  //   // Update state only if date is valid
  //   if (!error) {
  //     setitemreceivedDate(dayjs(date));
  //   }
  // };

  const handleValueChange = (value) => {
    setreceivedValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleClose = () => {
    navigate("../itemreceivedlist", { replace: true });
  };

  const InsertPOData = async (e) => {
    e.preventDefault();
    setButtonLoading(true);
    let formErrors = {};

    //if (dateerror) formErrors.errDate = "Invalid Item Receipt Date";
    //if (tpidateerror) formErrors.errtpiDate = "Invalid TPI Date";

    
    if (!itemreceivedDate)
      {
        formErrors.errDate = "Invalid Item Receipt Date";
       
      } 


      if (!showRemark && !tpiDate)
        {
          formErrors.errtpiDate = "Invalid TPI Date";
         
        } 
  




    if (
      !receivedQuantity ||
      isNaN(parseFloat(receivedQuantity)) ||
      parseFloat(receivedQuantity) <= 0
    ) {
      formErrors.qty = "Qty should be more than zero";
    }

    if (
      parseFloat(poQuantity) <
        parseFloat(receivedQuantity) + parseFloat(totalreceivedQuantity) ||
      parseFloat(poValue) <
        parseFloat(receivedValue) + parseFloat(totalreceivedValue)
    ) {
      formErrors.qty = "Quantity or Value is more than PO Value";
      formErrors.val = "Quantity or Value is more than PO Value";
      setError("Quantity or Value is more than PO Value");
    }

    if (
      !receivedValue ||
      isNaN(parseFloat(receivedValue)) ||
      parseFloat(receivedValue) <= 0
    ) {
      formErrors.val = "Value should be more than zero";
    }

    if (parseFloat(receivedQuantity) > parseFloat(poQuantity)) {
      formErrors.qty = "Qty should not be more than PO Quantity";
    }

    if (parseFloat(receivedValue) > parseFloat(poValue)) {
      formErrors.val = "Value should be more than PO Value";
    }

    if (!getpass || getpass.length === 0) {
      formErrors.getpass = "Memo/Getpass Number Should not be Blank";
    }

    if (selectedOption === "1") {
      if (tpiagency.length === 0)
        formErrors.tpierr = "TPI Agency Should not be Blank";
    }

    if (selectedOption === "0") {
      // SelectionTypeValue = "0";
      settpiAgency(" ");
    }

    if (selectedOption.length === 0) {
      formErrors.selerr = "Inspection Type Not Selected";
    }

    if (itemselectedOption.length === 0) {
      formErrors.selitemerr = "Item Received Type Menu Not Selected";
    }

    setErrors(formErrors);

    // const keys = Object.keys(formErrors);
    //const values = keys.map((key) => formErrors[key]);
    // console.log(values);

    //console.log(itemselectedOption);
    //console.log (formErrors);
    if (Object.keys(formErrors).length === 0) {
      const podt = new Date(itemreceivedDate);
      const indentreceiptdt =
        podt.getFullYear() +
        "/" +
        parseInt(podt.getMonth() + 1) +
        "/" +
        podt.getDate();

      // const tpidt1 = new Date(tpiDate);
      // const tpidat =
      //   tpidt1.getFullYear() +
      //   "/" +
      //   parseInt(tpidt1.getMonth() + 1) +
      //   "/" +
      //   tpidt1.getDate();


      let tpidat = "";

      if (!showRemark) {
        const tpidt1 = new Date(tpiDate);
        tpidat = `${tpidt1.getFullYear()}/${tpidt1.getMonth() + 1}/${tpidt1.getDate()}`;
      }


      apiClient
        .post("/itemReceiptEntry", {
          vpoNumber: npoNumber,
          vitemReceivedDate: indentreceiptdt,
          vreceivedItemQty: receivedQuantity,
          vreceivedItemValue: receivedValue,
          vreason: reason,
          ventryUser: uname,
          vtpidate: tpidat,
          vtpiagency: tpiagency,
          vtpitype: selectedOption,
          vip: ip,
          vgetpassnumber: getpass,
          vitemreceivedtype: itemselectedOption,
        })
        .then(function (response) {
          setError(response.data);
          setgetpass("");
          settpiAgency("");
          setreason("");
          getdata();
          

          if (
            parseFloat(poQuantity) ===
            parseFloat(receivedQuantity) + parseFloat(totalreceivedQuantity)
          ) {

            // navigate("../itemreceivedlist", { replace: true });
          }


          if (selectedOption === "1") {
            navigate("../itemreceivedlist", { replace: true });
          }
          
        })
        .catch(function (error) {
          if (
            error.response.data &&
            error.response.data.code === "ER_DUP_ENTRY"
          ) {
            alert("Duplicate Gate Entry Pass Number for this PO Not Allowed");
            setButtonLoading(false);
          }
          
        });

    }
   
  };

  const getdata = async (e) => {


     if (!indentId || indentId.trim() === "") return;
    setButtonLoading(true);
   // alert(indentId);


    try {
      const response1 = await apiClient.post("/podetails", {
        uname: uname,
        indentNumber: String(indentId),
      });

      // Setting state with response data

      // setpomainReturnData(response1.data[0]);

      
            //console.log(pomainReturnData);


         //   console.log(response1.data.data[0]);
      setpoindentnumber(response1.data.data[0].indentnumber);
      setpoNumber(response1.data.data[0].ponumber);
      setpoDate(response1.data.data[0].podate);
      setConsigneeName(response1.data.data[0].consignee);
      setpoItemName(response1.data.data[0].poitem);
      setpoQuantity(response1.data.data[0].quantity);
      setpoValue(response1.data.data[0].value);
      setDPDate(response1.data.data[0].DPDate);
      // DPDate
      settotBalanceqty(response1.data.data[0].balanceQty_receivedItem);
      settotBalanceVal(response1.data.data[0].balanceVal_receivedItem);

      setreceivedQuantity(response1.data.data[0].quantity);
      setreceivedValue(response1.data.data[0].value);

      


if (response1.data.data[0].gemtype === 0) {
       const minValueDate = "'" + dayjs(response1.data.data[0].podate).format("YYYY-MM-DD") + "'";
        setMinCalDate(dayjs(minValueDate));




      }
else
{
const gemDate = "'" + dayjs(response1.data.data[0].gemdate).format("YYYY-MM-DD") + "'";
setMinCalDate(dayjs(gemDate));
setGeMNumber(response1.data.data[0].gemno);
setGemDate(dayjs(response1.data.data[0].gemdate).format("YYYY-MM-DD"))
}

   



    //  setMinCalDate(dayjs(minValueDate));

      getPOdata(response1.data.data[0].quantity, response1.data.data[0].value);
      setButtonLoading(false);
    } catch (error) {
      setError(error.response1 ? error.response1.data : error.message);
      setButtonLoading(false);
    }

  };

  


  const getPOdata = async (quantity = 0, value = 0) => {
    setButtonLoading(true);
    try {
      const response = await apiClient.post("/getReceivedItembyPONumber", {
        ponumber: indentId,
      });
      // console.log(response?.data);
      setPOReturnData(response.data);

      let totalIndentQty = 0;
      let totalIndentValue = 0;
      response?.data?.forEach((item) => {
        totalIndentQty += +item?.ItemQuantity;
        totalIndentValue += +item?.ItemValue;
      });

      setreceivedQuantity((quantity - totalIndentQty).toFixed(2));
      setreceivedValue((value - totalIndentValue).toFixed(2));

      settotalreceivedQuantity(totalIndentQty);
      settotalreceivedValue(totalIndentValue);
    } catch (err) {
      setError(err.response?.data || err.message);
    }
    setButtonLoading(false);
  };

  useEffect(() => {
    setButtonLoading(true);
    getdata();
    setButtonLoading(false);
  }, []);

  const headers = [
    //["Indent Number","",""],, ""
    ["Indent Number", "PO Number", "Item Name"],
    ["PO date", "PO Quantity", "PO Value"],
    ["DP date","GeM Number","Gem Date"],
    ["Consignee", "Receivable Quantity", "Receivable Value"],
  ];

  const rows = [
    [poindentnumber, npoNumber, poItemName],
    [poDate, poQuantity, poValue],
    [dpDate,GeMNumber,GemDate],
    [ConsigneeName, totBalanceqty, totBalanceVal],
  ];

  const itemreceivedmenuoptions = [
    { value: "0", label: "All Item Received" },
    { value: "1", label: "Partial Item Received" },
    { value: "2", label: "Final Item of Partial Received Items" },
  ];

  const inseptionmenuoptions = [
    { value: "0", label: "Consignee" },
    { value: "1", label: "Pre Inspected" },
  ];

  const columns = [
    "getpassnumber",
    "itemReceivedDate",
    "ItemQuantity",
    "ItemValue",
    "TPIDESC"
  ];

  const columnNames = [
    "Gate Entry/Challan/Invoice Number",
    "Received Date",
    "Quantity",
    "Value",
    "Inspection Type",
  ]; // keys from your data objects


  const poCancelConfirm = async () => {
    const isConfirmed = window.confirm(
      `Are you sure you want to Cancel PO Number: ${indentId}\n\nCaution : Duplicate PO cannot be created again.`
    );
      if (isConfirmed) {
        setShowcancleRemark(true);
            }

      else
      {
        setShowcancleRemark(false);
        setcancleRemark("");
      }
    };


    const poCancel = async () => {
      setPageLoader(true);
      const isConfirmed = window.confirm(
        `Are you sure to Cancel PO Number: ${indentId}\n\nCaution : Duplicate PO cannot be created again.`
      );
        if (isConfirmed) {
        
        try {
          const response = await apiClient.post("/pocancel", {
            vponumber: String(indentId),
            ventryUser: uname,
            vip: ip,
            vreason: cancleRemark,
            
          });
    
          navigate('../', { replace: true });
        } catch (error) {
        //alert(error);
        navigate('../', { replace: true });
        }
        }
  
        else
        {
          setShowcancleRemark(false);
          setcancleRemark("");
        }
        setPageLoader(false);
      };



  const getUnsutablePOdata = useCallback(async () => {
if (!indentId || indentId.trim() === "") return;
    try {
      const response = await apiClient.post("/getUnsutablePO_by_PONumber", {
        ponumber: String(indentId),
        gatepassnumber:'',
      });

     //  console.log(response.data[0].unsuitabilitytype);


        if (response.data[0].unsuitabilitytype === "Suitable") {
          setSuitabilityDone("Suitable")
        } 



        
      setunsuitablePOList(response.data);





    } catch (err) {}
  }, [String(indentId)]); // Include indentNo in the dependency array if getPOdata depends on it

  useEffect(() => {
    // Update state if roles change (in case roles are updated dynamically)
    getUnsutablePOdata();
  }, [String(indentId)]);

  

const columns1 = [
  "getpassnumber",
    "unsuitabilitytype",
    "SuitabilityDate",
    "reason",
    "receivedItemQty",

  ];

  const columnNames1 = [
    "Gate Entry/Challan/Invoice Number",
    "Insepction Result",
    "Date",
    "Reason",
    "Quantity",
    
  ]; // keys from your data objects


  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

  

 return (
  <>
    <style>{`
      /* =========================================================
         ITEM RECEIVED ENTRY - DASHBOARD THEME
         ========================================================= */

      .item-received-page {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 12px;
        overflow-x: hidden;
      }

      .item-received-card {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid #dbe5f1 !important;
        border-radius: 16px !important;
        overflow: hidden;
        box-shadow: 0 5px 18px rgba(13, 71, 161, 0.10) !important;
      }

      /* ---------- Main Header ---------- */

      .item-received-header {
        width: 100%;
        box-sizing: border-box;
        padding: 15px 20px;
        color: #ffffff;
        font-size: 20px;
        font-weight: 700;
        letter-spacing: 0.2px;
        background: linear-gradient(
          135deg,
          #0d47a1 0%,
          #1565c0 50%,
          #1976d2 100%
        );
        display: flex;
        align-items: center;
        min-height: 58px;
      }

      .item-received-content {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 18px !important;
      }

      /* ---------- PO Details Accordion ---------- */

      .item-po-accordion {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        margin-bottom: 20px !important;
        border: 1px solid #d7e4f5 !important;
        border-radius: 12px !important;
        overflow: hidden;
        box-shadow: 0 3px 12px rgba(13, 71, 161, 0.07) !important;
      }

      .item-po-accordion::before {
        display: none;
      }

      .item-po-summary {
        min-height: 52px !important;
        background: linear-gradient(
          135deg,
          #eaf3ff 0%,
          #f5f9ff 100%
        ) !important;
        color: #0d47a1 !important;
        padding: 0 16px !important;
      }

      .item-po-summary .MuiAccordionSummary-content {
        margin: 12px 0 !important;
      }

      .item-po-summary .MuiAccordionSummary-expandIconWrapper {
        color: #1565c0;
      }

      .item-po-title {
        font-weight: 700 !important;
        font-size: 16px !important;
      }

      .item-po-details {
        padding: 16px !important;
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        overflow: hidden;
      }

      /* ---------- Form Section ---------- */

      .item-form-section {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        margin-top: 18px;
      }

      .item-form-grid {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;

        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
      }

      .item-form-field {
        width: 100%;
        min-width: 0;
        box-sizing: border-box;
      }

      /* ---------- Two Column Groups ---------- */

      .item-two-column {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;

        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
        margin-top: 16px;
      }

      /* ---------- Full Width ---------- */

      .item-full-width {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        margin-top: 16px;
      }

      /* ---------- Table Sections ---------- */

      .item-table-section {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        margin-top: 22px;
        overflow: hidden;
      }

      .item-section-title {
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 10px;
        padding: 10px 14px;

        color: #0d47a1;
        background: linear-gradient(
          135deg,
          #edf5ff,
          #f7fbff
        );

        border-left: 4px solid #1565c0;
        border-radius: 7px;

        font-size: 15px;
        font-weight: 700;

        overflow-wrap: anywhere;
        word-break: break-word;
      }

      /* ---------- Buttons ---------- */

      .item-action-bar {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;

        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        justify-content: flex-end;

        margin-top: 24px;
        padding: 0;
      }

      .item-action-btn {
        min-width: 145px;
        border: none;
        border-radius: 8px;
        padding: 10px 18px;

        color: #ffffff;
        font-size: 14px;
        font-weight: 700;

        cursor: pointer;
        transition: all 0.2s ease;

        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);
      }

      .item-action-btn:hover {
        transform: translateY(-1px);
        box-shadow: 0 5px 12px rgba(0, 0, 0, 0.18);
      }

      .item-save-btn {
        background: linear-gradient(
          135deg,
          #0d47a1,
          #1976d2
        );
      }

      .item-cancel-btn {
        background: linear-gradient(
          135deg,
          #c62828,
          #e53935
        );
      }

      .item-back-btn {
        background: linear-gradient(
          135deg,
          #455a64,
          #607d8b
        );
      }

      .item-final-cancel-btn {
        background: linear-gradient(
          135deg,
          #212121,
          #424242
        );
      }

      .item-action-btn:disabled {
        opacity: 0.65;
        cursor: not-allowed;
        transform: none;
      }

      /* ---------- Cancellation Area ---------- */

      .item-cancellation-box {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;

        margin-top: 24px;
        padding: 18px;

        background: #fff8f8;
        border: 1px solid #ffcdd2;
        border-radius: 12px;
      }

      .item-cancellation-title {
        color: #b71c1c;
        font-size: 15px;
        font-weight: 700;
        margin-bottom: 12px;
      }

      .item-cancellation-action {
        display: flex;
        justify-content: flex-end;
        margin-top: 12px;
      }

      /* ---------- Loader ---------- */

      .item-loader {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px 20px;
      }

      /* =========================================================
         TABLE RESPONSIVENESS
         ========================================================= */

      .item-table-section table,
      .item-table-section .dynamic-data-table,
      .item-table-section .lh-table {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
      }

      /* =========================================================
         TABLET
         ========================================================= */

      @media (max-width: 900px) {
        .item-received-page {
          padding: 8px;
        }

        .item-received-content {
          padding: 14px !important;
        }

        .item-form-grid,
        .item-two-column {
          grid-template-columns: 1fr;
        }

        .item-action-bar {
          justify-content: stretch;
        }

        .item-action-btn {
          flex: 1 1 200px;
        }
      }

      /* =========================================================
         MOBILE
         ========================================================= */

      @media (max-width: 600px) {
        .item-received-page {
          padding: 4px;
        }

        .item-received-card {
          border-radius: 11px !important;
        }

        .item-received-header {
          padding: 13px 14px;
          font-size: 17px;
          min-height: 50px;
        }

        .item-received-content {
          padding: 10px !important;
        }

        .item-po-summary {
          padding: 0 10px !important;
        }

        .item-po-title {
          font-size: 14px !important;
        }

        .item-po-details {
          padding: 8px !important;
        }

        .item-form-grid,
        .item-two-column {
          grid-template-columns: 1fr;
          gap: 10px;
        }

        .item-form-section {
          margin-top: 12px;
        }

        .item-full-width {
          margin-top: 10px;
        }

        .item-table-section {
          margin-top: 16px;
        }

        .item-section-title {
          font-size: 13px;
          padding: 8px 10px;
        }

        .item-action-bar {
          flex-direction: column;
          gap: 9px;
          margin-top: 18px;
        }

        .item-action-btn {
          width: 100%;
          min-width: 0;
          flex: none;
        }

        .item-cancellation-box {
          margin-top: 16px;
          padding: 12px;
        }

        .item-cancellation-action {
          width: 100%;
        }

        .item-final-cancel-btn {
          width: 100%;
        }
      }

      /* =========================================================
         VERY SMALL MOBILE
         ========================================================= */

      @media (max-width: 380px) {
        .item-received-header {
          font-size: 16px;
        }

        .item-received-content {
          padding: 7px !important;
        }

        .item-po-details {
          padding: 5px !important;
        }
      }
    `}</style>

    <div className="item-received-page">
      <Card className="item-received-card">
        
        {/* =====================================================
            HEADER
        ===================================================== */}
        <div className="item-received-header">
          Received Item's Entry
        </div>

        <CardContent className="item-received-content">

          {/* ===================================================
              PO DETAILS
          =================================================== */}
          <Accordion
            defaultExpanded
            className="item-po-accordion"
          >
            <AccordionSummary
              expandIcon={<ArrowDownwardIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              className="item-po-summary"
            >
              <Typography
                component="span"
                className="item-po-title"
              >
                PO Details
              </Typography>
            </AccordionSummary>

            <AccordionDetails className="item-po-details">
              <ListHeaderTableComponent
                headers={headers}
                rows={rows}
              />
            </AccordionDetails>
          </Accordion>

          {/* ===================================================
              ENTRY FORM
          =================================================== */}
          <div className="item-form-section">

            {/* Gate Pass + Receiving Date */}
            <div className="item-two-column">

              <div className="item-form-field">
                <CustomTextField
                  label="Gate Entry Pass Number/ Memo Number/ Invoice Number"
                  value={getpass ?? ""}
                  onChange={(e) => {
                    setgetpass(e.target.value);
                  }}
                  placeholder="Enter Entry Pass Number/ Memo Number/ Invoice Number"
                  maxLength={50}
                  error={!!errors.getpass}
                  helperText={errors.getpass}
                />
              </div>

              <div className="item-form-field">
                <DatePickerComponent
                  label="Item Receiving Date"
                  id="receiveddate"
                  value={itemreceivedDate}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setitemreceivedDate
                    )
                  }
                  error={errors.errDate}
                  maxDate={maxDate}
                  minDate={minCalDate}
                />
              </div>

            </div>

            {/* Quantity + Value */}
            <div className="item-two-column">

              <div className="item-form-field">
                <NumericTextField
                  id="receivedItemQuantity"
                  label="Received Item Quantity"
                  title="Received Item Quantity"
                  error={errors.qty}
                  value={receivedQuantity ?? "0"}
                  onChange={handleQuantityChange}
                />
              </div>

              <div className="item-form-field">
                <NumericTextField
                  id="receivedItemValue"
                  label="Received Item Value"
                  title="Received Item Value"
                  error={errors.val}
                  value={receivedValue ?? "0"}
                  onChange={handleValueChange}
                />
              </div>

            </div>

            {/* Received Type + Inspection */}
            <div className="item-two-column">

              <div className="item-form-field">
                <CustomDropdownMenu
                  options={itemreceivedmenuoptions}
                  selectedOption={itemselectedOption}
                  handleOptionChange={handleOptionitemChange}
                  error={errors.selitemerr}
                  menulabel="Select Item Received Option"
                />
              </div>

              <div className="item-form-field">
                <CustomDropdownMenu
                  options={inseptionmenuoptions}
                  selectedOption={selectedOption}
                  handleOptionChange={handleOptionChange}
                  error={errors.selerr}
                  menulabel="Select Pre Inspection Option"
                />
              </div>

            </div>

            {/* =================================================
                TPI DETAILS
            ================================================= */}
            {!showRemark && (
              <div className="item-two-column">

                <div className="item-form-field">
                  <DatePickerComponent
                    label="TPI Date"
                    id="tpidate"
                    value={tpiDate}
                    onChange={(newDate) =>
                      handleDateChange(
                        newDate,
                        setTpiDate
                      )
                    }
                    error={errors.errtpiDate}
                    maxDate={
                      itemreceivedDate
                        ? dayjs(itemreceivedDate)
                        : dayjs()
                    }
                    minDate={minCalDate}
                  />
                </div>

                <div className="item-form-field">
                  <CustomTextField
                    label="TPI Agency"
                    value={tpiagency ?? ""}
                    onChange={(e) => {
                      settpiAgency(e.target.value);
                    }}
                    placeholder="TPI Agency"
                    maxLength={50}
                    error={!!errors.tpierr}
                    helperText={errors.tpierr}
                  />
                </div>

              </div>
            )}

            {/* =================================================
                REMARK
            ================================================= */}
            <div className="item-full-width">
              <CustomTextField
                label="Remark if Any ---> it should be not blank if Quantity or Value is not as per PO Value"
                value={reason ?? ""}
                onChange={(e) => {
                  setreason(e.target.value);
                }}
                placeholder="Reason"
                maxLength={50}
                error={!!errors.err}
                helperText={errors.err}
              />
            </div>

          </div>

          {/* ===================================================
              RECEIVED PO ITEMS TABLE
          =================================================== */}
          {POReturnData.length > 0 && (
            <div className="item-table-section">
              <TablewithSumFooter
                columns={columns}
                columnNames={columnNames}
                data={POReturnData}
                showProceedButton={true}
                buttonName="Item Proceed"
                rowNameKey="suitabilitystatus"
                valueKey={0}
                onButtonClick={handleButtonClick}
              />
            </div>
          )}

          {/* ===================================================
              SUITABILITY / INSPECTION TABLE
          =================================================== */}
          {unsuitablePOList.length > 0 && (
            <div className="item-table-section">

              <div className="item-section-title">
                List of suitable/unsuitable done by Inspection Section
              </div>

              <TablewithSumFooter
                columns={columns1}
                columnNames={columnNames1}
                data={unsuitablePOList}
              />

            </div>
          )}

          {/* ===================================================
              ACTION BUTTONS
          =================================================== */}
          <div className="item-action-bar">

            <button
              className="item-action-btn item-save-btn"
              type="button"
              onClick={InsertPOData}
              title="Click for Data Save"
              disabled={buttonLoading}
            >
              {buttonLoading ? "Saving..." : "Save Data"}
            </button>

            {suitabilityDone !== "Suitable" && (
              <button
                className="item-action-btn item-cancel-btn"
                type="button"
                onClick={poCancelConfirm}
                title="Click for Cancel PO"
              >
                PO Cancel / Drop
              </button>
            )}

            <button
              className="item-action-btn item-back-btn"
              type="button"
              onClick={handleClose}
              title="Back to List"
            >
              Back to List
            </button>

          </div>

          {/* ===================================================
              FINAL PO CANCELLATION
          =================================================== */}
          {showcancleRemark && (
            <div className="item-cancellation-box">

              <div className="item-cancellation-title">
                PO Cancellation
              </div>

              <CustomTextField
                label="Remark --> it should be not blank"
                value={cancleRemark ?? ""}
                onChange={(e) => {
                  setcancleRemark(e.target.value);
                }}
                placeholder="Cancellation Reason"
                maxLength={50}
                error={!!errors.err}
                helperText={errors.err}
              />

              <div className="item-cancellation-action">

                {pageLoader ? (
                  <div className="item-loader">
                    <CircularProgress size={28} />
                  </div>
                ) : (
                  <button
                    className="item-action-btn item-final-cancel-btn"
                    type="button"
                    onClick={poCancel}
                    title="Click for Cancel PO"
                  >
                    Click here: Finally Submit Cancellation
                  </button>
                )}

              </div>

            </div>
          )}

        </CardContent>
      </Card>
    </div>
  </>
);
}

export default ItemReceivedEntry;
